import type { AnalysisType } from 'config/analysisConfig';

type BranchGraphDatasetLike = {
  getLumenAreaValue: (branchId: number, index: number) => number | null;
  getLumenDiameterValue: (branchId: number, index: number) => number | null;
  getLengthValue: (branchId: number, index: number) => number | null;
  getWallAreaValue: (branchId: number, index: number) => number | null;
  getWallDiameterValue: (branchId: number, index: number) => number | null;
  getSlicePlaquePersent: (
    branchId: number,
    index: number,
  ) =>
    | {
        lowattenuationPersent?: number;
        noncalcifiedPersent?: number;
        calcifiedPersent?: number;
        lumenPersent?: number;
      }
    | null
    | undefined;
};

export type CrossSectionMetricOverlay = {
  lumenArea: number | null;
  lumenDiameter: number | null;
  length: number | null;
  wallArea: number | null;
  wallDiameter: number | null;
  plaquePercent:
    | {
        lowattenuationPersent?: number;
        noncalcifiedPersent?: number;
        calcifiedPersent?: number;
        lumenPersent?: number;
      }
    | null
    | undefined;
};

function supportsCrossSectionMetricOverlay(analysisType: AnalysisType) {
  return (
    analysisType === 'plaque' ||
    analysisType === 'fai' ||
    analysisType === 'stenosis' ||
    analysisType === 'isr'
  );
}

function subtractMetric(a: number, b: number) {
  return Number((a - b).toFixed(12));
}

export function getCrossSectionMetricOverlay({
  analysisType,
  branchGraphDataset,
  branchId,
  index,
}: {
  analysisType: AnalysisType;
  branchGraphDataset: BranchGraphDatasetLike | null | undefined;
  branchId: number;
  index: number | null | undefined;
}): CrossSectionMetricOverlay | null {
  if (!supportsCrossSectionMetricOverlay(analysisType)) return null;
  if (!branchGraphDataset || !Number.isFinite(index)) return null;

  const safeIndex = Number(index);
  const lumenArea = branchGraphDataset.getLumenAreaValue(branchId, safeIndex);
  const wallAreaValue =
    analysisType === 'plaque'
      ? branchGraphDataset.getWallAreaValue(branchId, safeIndex)
      : null;

  return {
    lumenArea,
    lumenDiameter: branchGraphDataset.getLumenDiameterValue(branchId, safeIndex),
    length: branchGraphDataset.getLengthValue(branchId, safeIndex),
    wallArea:
      analysisType === 'plaque' &&
      typeof wallAreaValue === 'number' &&
      typeof lumenArea === 'number'
        ? subtractMetric(wallAreaValue, lumenArea)
        : null,
    wallDiameter:
      analysisType === 'plaque'
        ? branchGraphDataset.getWallDiameterValue(branchId, safeIndex)
        : null,
    plaquePercent: branchGraphDataset.getSlicePlaquePersent(branchId, safeIndex),
  };
}
